import { FC } from 'react';
import styles from './dashboard.module.scss';
import { InputSummary } from '@app/modules/projects/dashboard/pwerm2-widgets/input-summary/InputSummary';
import { ValuationConclusion } from './pwerm2-widgets/valuation-conclusion/ValuationConclusions';
import { SimulatedOutcomesChartTypes } from './opm-widgets/stacked-distribution/opm-enums';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { usePwcNavigate } from '@app/core/hooks/routing-hooks';
import { RouteConstants } from '../RouteConstants';
import { Navigate } from 'react-router-dom';
import { CollarRealWorld } from './pwerm2-widgets/collar-real-world/CollarRealWorld';
import { SimulatedOutcomes } from './opm-widgets/simulated-outcomes/SimulatedOutcomes';

const PARENT_CLASSNAME = 'opm-dashboard-grid';

const DashboardOpm: FC = (): JSX.Element => {
  const results = useAppSelector((state) => state.opmCalculation.riskFreeValues);
  const { generatePath } = usePwcNavigate();

  // redirect the user if there is no data
  if (!results || Object.keys(results).length === 0) {
    const newPath = generatePath(`../${RouteConstants.ProjectDetails}`);
    return <Navigate to={newPath} replace />;
  }

  return (
    <div className={styles[PARENT_CLASSNAME]}>
      <div className={styles['input-container']}>
        <InputSummary />
        <CollarRealWorld />
      </div>
      <ValuationConclusion />
      <SimulatedOutcomes chartType={SimulatedOutcomesChartTypes.RiskFreeOutcome} />
    </div>
  );
};

export default DashboardOpm;
